import { useGetProductBySlugQuery } from 'core/services';
import { useParams, useRouteMatch } from 'react-router-dom';

const productPath = '/product/:supplier_code/:brand_slug/:slug';

const useSkipForProduct = () => {
  const match = useRouteMatch();
  const { slug, supplier_code } = useParams();

  const isOnProductPage = match?.path?.includes(productPath);

  const { isLoading } = useGetProductBySlugQuery(
    { slug, supplier_code },
    { skip: !isOnProductPage },
  );

  return isLoading;
};

export default useSkipForProduct;
